import { restClient } from '../../client';
import { Match, User, UserProfile } from '../../resources';


export const getProviderActivePatients = (providerId: string) =>
  restClient.request<{
    data: {
      user: User;
      profile: UserProfile;
      match: Match;
    }[];
  }>(`/api/v1/provider/${providerId}/active-patients`);
